module.exports = ($scope, $upload, $uibModalInstance, endpoints, workflowStep, manualSource, User) ->
  $scope.visile = false
  $scope.newDoc = {}
  $scope.uploading = false
  $scope.uploaded = false
  $scope.progressPercentage = 0
  $scope.files = []

  $scope.addFiles = (files) ->
    $scope.files.push.apply $scope.files, files

  $scope.disableUpload = (files) ->
    (f for f in files when f.uploading != false and f.uploaded != false).length == 0

  $scope.supportedExtensions = [
      'csv', 'doc', 'docx', 'html', 'pdf', 'ppt', 'pptx', 'rtf', 'txt', 'xls', 'xlsx', 'xps',
      'jpg', 'jpeg', 'png', 'bmp', 'gif', 'htm'
  ]

  # If you update this list, make sure to update the corresponding list in
  # the back-end (FILE_NAME_REJECT_SYMBOLS in django_settings.py)
  $scope.rejectSymbols = [
    ';', ':', '>', '<', '/', '\\', '*', '%', '$'
  ]
  $scope.rejectSymbolsString = $scope.rejectSymbols.join(' ')

  if User.getSupportedExtensions()?.length > 0
    $scope.supportedExtensions = User.getSupportedExtensions()

  $scope.isExtensionSupported = (fileName) ->
    (ext for ext in $scope.supportedExtensions when fileName.substr(-ext.length).toLowerCase() == ext).length > 0

  $scope.validateFileNameLength = (fileName) ->
    fileName.length < 255

  $scope.isFileNameContainsMoreThanOneDot = (fileName) ->
    fileName.split('.').length > 2

  $scope.isFileNameContainsSpecialChars = (fileName) ->
    for rejectSymbol in $scope.rejectSymbols
      if fileName.includes(rejectSymbol)
        return true
    return false

  $scope.validateFileName = (fileName) ->
    $scope.isExtensionSupported(fileName) and
      $scope.validateFileNameLength(fileName) and
      !$scope.isFileNameContainsMoreThanOneDot(fileName) and
      !$scope.isFileNameContainsSpecialChars(fileName)


  $scope.upload = () ->
    if $scope.files?
      for file, key in $scope.files when file.uploading != true and file.uploaded != true and $scope.validateFileName(file.name)
        file.uploading = true
        file.key = key
        $upload.upload
          url: endpoints.ProjectStarredDocument,
          data:
            field: 'value'
            workflow_step: workflowStep.id
            manual_source: manualSource
            'title': file.name
            'relevance_type': 'red'
          file: file
        .progress (event) ->
          $scope.files[event.config.file.key].progressPercentage = Math.round(100.0 * event.loaded / event.total)
        .success (starredDoc, status, headers, config) ->
          $scope.files[config.file.key].uploaded = true
          $scope.files[config.file.key].uploading = false
          $scope.files[config.file.key].id = starredDoc.id
          $scope.files[config.file.key].manual_source = starredDoc.manual_source
          $scope.files[config.file.key].title = starredDoc.title
        .error (data, status, headers, config) ->
          $scope.files[config.file.key].uploading = false
          $scope.files[config.file.key].uploaded = false
          $scope.files[config.file.key].error = true

  $scope.cancel = ->
    $uibModalInstance.close docs: (f for f in $scope.files when f.uploaded == true)
    return
